import { ReactNode } from 'react';

import { Message, Pill } from '@iwoca/orion';

import styles from './OfferCard.module.css';
import { useNumberFormat } from '../../hooks/useNumberFormat';
import { TGetOffersResponse, TOfferPill } from '../../types';
import IconWithText from '../IconWithText/IconWithText';

type TProps = {
  probability?: TGetOffersResponse['data']['offers'][number]['probability_of_offer'];
  amount: number;
  productDetails: ReactNode;
  button: ReactNode;
  pills?: TOfferPill[];
  error: string | null;
  confirmedOffer?: boolean;
};

const OfferCard = ({
  amount,
  productDetails,
  button,
  pills,
  error,
  confirmedOffer,
}: TProps) => {
  const { formatCurrency } = useNumberFormat();

  return (
    <section className={styles.container}>
      <div className={styles.groupContainer}>
        <div className={styles.group}>
          <div className={styles.header}>
            <h3 className={styles.heading}>
              {confirmedOffer ? (
                <span>Confirmed offer:</span>
              ) : (
                <span>Applying for:</span>
              )}{' '}
              <span className={styles.offerAmount}>
                {formatCurrency(amount)}
              </span>
            </h3>
            {pills && (
              <div className={styles.pills}>
                {pills.map((pill) => (
                  <div className={styles.pillContainer} key={pill.key}>
                    <Pill variant={pill.variant}>{pill.value}</Pill>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className={styles.group}>{productDetails}</div>
        <div className={styles.group}>
          <div className={styles.loanDetails}>
            {confirmedOffer ? (
              <ul>
                <li>
                  <IconWithText icon="lightningBolt">
                    Take money now
                  </IconWithText>
                </li>
                <li>
                  <IconWithText icon="checkSquare">
                    No documents required
                  </IconWithText>
                </li>
              </ul>
            ) : (
              <ul>
                <li>
                  <IconWithText icon="timerOutline">
                    Decision in 24 hours
                  </IconWithText>
                </li>
                <li>
                  <IconWithText icon="filePlusInside">
                    Documents required
                  </IconWithText>
                </li>
              </ul>
            )}
          </div>
          <div className={styles.offerCTA}>{button}</div>
          {error && (
            <Message className={styles.error} message={error} type="error" />
          )}
        </div>
      </div>
    </section>
  );
};

export default OfferCard;
